import React from 'react';
import { InputAdornment, TextField } from "@mui/material"
import { Search } from '@mui/icons-material';
import { color } from "../StyleData/Config";

export const Filter = ({ column }) => {

  return (
    <div style={{ marginTop: 5 }}>
      {column.canFilter ? column.render('Filter') : <div style={{ height: "2.3em" }}></div>}
    </div>
  );
};

export const GlobalFilter = ({ filter, setFilter, placeholder }) => {
  // console.log(filter)
  return (
    <TextField
      variant='outlined'
      size='small'
      fullWidth
      value={filter || ''}
      onChange={(e) => {
        setFilter(e.target.value || undefined);
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search sx={{ color: "#9AA0A6", fontSize: "1.2rem" }} />
          </InputAdornment>
        ),
      }}
      placeholder={placeholder || "Search"}
      sx={{
        backgroundColor: color.TableContainerSearchBgColor,
        "& .MuiOutlinedInput-root": {
          borderRadius: "8px",
          "& fieldset": { borderColor: "#B0B0B0" },
          "&:hover fieldset": { borderColor: "#8F8F8F" },
          "&.Mui-focused fieldset": { borderColor: "#6B7280" },
        },
        "& .MuiOutlinedInput-input::placeholder": {
          opacity: 1,
          color: "#7A7A7A",
          fontSize: "0.9rem",
        },
      }}
    />
  )

}

export const DefaultColumnFilter = ({
  column: {
    filterValue,
    setFilter,
    preFilteredRows: { length },
    Header
  },

}) => {

  return (
    <TextField
      variant='standard'
      size='small'
      fullWidth
      value={filterValue || ''}
      onChange={(e) => {
        setFilter(e.target.value || undefined);
      }}
      placeholder={`${Header}`}
      sx={{
        "& .MuiInputBase-input::placeholder": {
          opacity: 1,
          color: "#7A7A7A",
          fontSize: "0.9rem",
        },
      }}
    />
  );
};

export const SelectColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
}) => {
  const options = React.useMemo(() => {
    const options = new Set();
    preFilteredRows.forEach((row) => {
      options.add(row.values[id]);
    });
    return [...options.values()];
  }, [id, preFilteredRows]);

  return (
    <TextField
      id='custom-select'
      type='select'
      value={filterValue}
      onChange={(e) => {
        setFilter(e.target.value || undefined);
      }}
    >
      <option value=''>All</option>
      {options.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </TextField>
  );
};

/**
 * Filters out options with label or value 'none' (case-insensitive).
 * @param {Array} options - Array of option objects (with 'label' and/or 'value').
 * @returns {Array} Filtered options array.
 */
export function filterNoneOptions(options) {
  if (!Array.isArray(options)) return options;
  return options.filter(opt => {
    // Some select lists use 'label', some use 'text', some use 'name'
    const displayStr = (opt.label || opt.text || opt.name || '').toLowerCase();
    const value = (typeof opt.value === 'string' ? opt.value.toLowerCase() : opt.value);

    return displayStr !== 'none' && value !== 'none';
  });
}
